function OnboardingSidebarMenuItemDirective() {
  return {
    restrict: 'E',
    scope: {},
    template: `<li class="setup-tasks" ng-if="!onboardingCompleteOnPageLoad && organization.type !== 'LIMITED_EXTERNAL'">
      <a ui-sref="app.organization.welcome" ui-sref-active="active">
        <i class="ion-alert-circled"></i>
        <p>Setup Tasks</p>
        <div class="setup-tasks-circle" ng-class="{ 'updated' : stepsUpdated, 'complete' : stepsRemaining() === 0 }">
          <i class="icon ion-checkmark"></i>
          <span class="number">{{ stepsRemaining() }}</span>
        </div>
      </a>
    </li>`,
    controller: 'onboardingSidebarMenuItemCtrl'
  };
}

OnboardingSidebarMenuItemDirective.$inject = [];

export default OnboardingSidebarMenuItemDirective;



// WEBPACK FOOTER //
// ./src/directives/onboardingSidebarMenuItem/index.js